import { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useStoreList } from 'queries/useESignQueries.js';
import MyColor from 'utils/MyColor.js';
import useBusinessNumber from './hooks/useBusinessNumber.jsx';
import Loading from 'components/Loading.jsx';

export default function ESignApplicationContainer({ children }) {
  const { businessNumber } = useBusinessNumber();
  const navigate = useNavigate();
  const { data: storeList = [], isLoading } = useStoreList(businessNumber);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (storeList?.length === 0) {
      alert('계약할 매장이 존재하지 않습니다');
      navigate('/e-sign');
    }
  }, [storeList, isLoading]);

  if (isLoading || storeList?.length === 0) {
    return <Loading />;
  }

  return (
    <Main>
      <MainColumn>{children}</MainColumn>
    </Main>
  );
}

const Main = styled.main`
  padding-bottom: 110px;
  min-height: 100vh;
  background-color: ${MyColor.grayF9F9FA};
  width: 100%;

  @media (max-width: 1000px) {
    padding: 20px 16px 16px 16px;
    background-color: #fff;
  }
`;

const MainColumn = styled.div`
  width: 1000px;
  margin: auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  gap: 30px;

  @media (max-width: 1000px) {
    width: 100%;
    gap: 24px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  margin-left: auto;
  gap: 25px;

  @media (max-width: 1000px) {
    gap: 8px;
    margin-left: 0;
  }
`;

export const Button = styled.button`
  padding: 14px 0;
  width: 160px;
  border-radius: 6px;
  font-weight: 600;
  background-color: ${(props) => props.bgColor || MyColor.brand40};
  color: ${(props) => props.color || '#ffffff'};

  @media (max-width: 1000px) {
    flex: 1;
    width: auto;
  }

  &:disabled {
    background-color: ${MyColor.gray10};
    color: ${MyColor.gray9C9C9C};
  }
`;

export const PrevButton = styled.button`
  padding: 14px 0;
  width: 160px;
  border-radius: 6px;
  font-weight: 600;
  background-color: ${(props) => props.bgColor || MyColor.brand40};
  color: ${(props) => props.color || '#ffffff'};

  @media (max-width: 1000px) {
    width: 124px;
  }
`;
